import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-secondary-100">
      <div className="mx-auto max-w-content px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-2">
            <div className="flex items-center gap-3">
              <img
                src="https://static.readdy.ai/image/ab81c99bf13c746e82ce9665f9429731/820e8067564a5d8f57c6b05c1c531e9b.png"
                alt="HANDICALC®"
                className="w-12 h-12 object-contain rounded-md"
                loading="lazy"
              />
              <span className="font-heading font-bold text-background-50 text-lg">
                HANDICALC<sup className="text-[10px] font-medium">®</sup>
              </span>
            </div>
            <p className="mt-4 text-sm text-secondary-200 max-w-md leading-relaxed">
              The fast, accurate Golf Shot Allowance Calculator for golfers, clubs and societies.
              Built around the World Handicap System™ — used by competition organisers worldwide.
            </p>
            <div className="mt-6 flex items-center gap-4">
              <a
                href="https://apps.apple.com/gb/app/handicalc/id6757720525"
                target="_blank"
                rel="noopener noreferrer"
                className="w-[140px] h-[48px] flex-shrink-0 cursor-pointer transition-transform hover:scale-105"
                aria-label="Download HANDICALC on the App Store"
              >
                <img
                  src="https://developer.apple.com/app-store/marketing/guidelines/images/badge-download-on-the-app-store.svg"
                  alt="Download on the App Store"
                  className="w-full h-full object-contain"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.wnapp.id1773163661064"
                target="_blank"
                rel="noopener noreferrer"
                className="w-[140px] h-[48px] flex-shrink-0 cursor-pointer transition-transform hover:scale-105"
                aria-label="Get HANDICALC on Google Play"
              >
                <img
                  src="https://public.readdy.ai/ai/img_res/edited_714094e88e03320dda08007cdcd15bfb_2a3910ca.jpg"
                  alt="Get it on Google Play"
                  className="w-full h-full object-contain"
                />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">
              <a href="#explore" className="cursor-pointer">Explore</a>
            </h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/calculator" className="text-secondary-200 hover:text-background-50 cursor-pointer whitespace-nowrap">Calculator</Link></li>
              <li><Link to="/how-it-works" className="text-secondary-200 hover:text-background-50 cursor-pointer whitespace-nowrap">How it works</Link></li>
              <li><Link to="/formats" className="text-secondary-200 hover:text-background-50 cursor-pointer whitespace-nowrap">Formats</Link></li>
              <li><Link to="/faq" className="text-secondary-200 hover:text-background-50 cursor-pointer whitespace-nowrap">FAQ</Link></li>
              <li><Link to="/challenge" className="text-secondary-200 hover:text-background-50 cursor-pointer whitespace-nowrap">Challenge</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">
              <a href="#company" className="cursor-pointer">Company</a>
            </h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/contact" className="text-secondary-200 hover:text-background-50 cursor-pointer whitespace-nowrap">Contact</Link></li>
              <li><Link to="/privacy" className="text-secondary-200 hover:text-background-50 cursor-pointer whitespace-nowrap">Privacy</Link></li>
              <li><Link to="/terms" className="text-secondary-200 hover:text-background-50 cursor-pointer whitespace-nowrap">Terms</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-secondary-800 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 text-xs text-secondary-300">
          <span>© {year} HANDICALC® — all rights reserved.</span>
          <span className="max-w-2xl sm:text-right leading-relaxed">
            World Handicap System™ and WHS™ are trademarks of The R&amp;A and the USGA.
            HANDICALC® is not affiliated with or endorsed by The R&amp;A or the USGA.
          </span>
        </div>
      </div>
    </footer>
  );
}